var _defs, _line, _path, _line2, _line3, _path2, _line4, _line5, _polyline, _polyline2, _polyline3, _polyline4, _rect, _rect2, _polyline5, _rect3, _polyline6, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#2e368f;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.49,
    y1: 48.22,
    x2: 151.31,
    y2: 48.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.09,52.39S153.86,27.87,140,27.87H79.88A14.81,14.81,0,0,0,66.7,35.61a22.18,22.18,0,0,0-2.25,11.28c.59,15.51,0,113,0,113s-.29,11.71,20.2,11.41c16.37-.23,41.14-.09,50.44,0a16.54,16.54,0,0,0,11.76-4.58,14.44,14.44,0,0,0,4.44-10.31c.24-12-.11-12.41-.11-12.41"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.49,
    y1: 48.22,
    x2: 151.31,
    y2: 48.22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.49,
    y1: 152.22,
    x2: 151.31,
    y2: 152.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.72,52.39S61.94,27.87,75.84,27.87h60.09a14.79,14.79,0,0,1,13.17,7.74,22,22,0,0,1,2.25,11.28c-.58,15.51,0,113,0,113s.3,11.71-20.19,11.41c-16.37-.23-41.15-.09-50.45,0A16.55,16.55,0,0,1,69,166.67a14.43,14.43,0,0,1-4.43-10.31c-.25-12,.11-12.41.11-12.41"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.31,
    y1: 48.22,
    x2: 64.5,
    y2: 48.22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.31,
    y1: 152.22,
    x2: 64.5,
    y2: 152.22
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "126.04 77.28 135.25 77.28 135.25 85.62"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "91.25 77.28 82.04 77.28 82.04 85.62"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "126.04 130.62 135.25 130.62 135.25 122.28"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "91.25 130.62 82.04 130.62 82.04 122.28"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.57,
    y: 85.62,
    width: 10.9,
    height: 11.27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.35,
    y: 86.19,
    width: 10.69,
    height: 10.69
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "109.21 83.61 109.21 103.98 89 103.98"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.57,
    y: 109.62,
    width: 10.9,
    height: 11.27
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "127.27 102.14 127.27 122.28 107.52 122.28"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.35,
    y1: 112.21,
    x2: 118.82,
    y2: 112.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.de029aba6c3da486136cb08d2ad5e52d.svg";
export { ForwardRef as ReactComponent };